export const messages = {
    "wre-dashboard.nav-menu.item.shared": "Deling",
    "wre-dashboard.nav-menu.item.backups": "Sikkerhedskopier",
    "wre-dashboard.nav-menu.item.machines": "Maskiner",
    "wre-dashboard.nav-menu.item.account": "Konto",
    "wre-dashboard.search.input.hint": "Søg",
    "wre-dashboard.search.label.breadcrumb": "Søgeresultater",
    "wre-dashboard.search.message.empty": "Ingen elementer matcher dine søgning",
    "wre-dashboard.side-bar.selected.title:plural": "{count} elementer er valgt | {count} element er valgt | {count} elementer er valgt",
    "wre-dashboard.side-bar.backup-type.disk": "Disk",
    "wre-dashboard.side-bar.backup-type.file": "Fil",
    "wre-dashboard.side-bar.backup-type.notarized": "Notarbekræftede filer og mapper",
    "wre-dashboard.side-bar.backup-type.exchange": "Program - Microsoft Exchange",
    "wre-dashboard.side-bar.backup-type.sql": "Program - Microsoft SQL",
    "wre-dashboard.side-bar.backup-type.sys-state": "Program - Systemtilstand",
    "wre-dashboard.side-bar.backup-type.application": "Applikation",
    "wre-dashboard.space-indicator.label.left": "{spaceFree} tilbage",
    "wre-dashboard.space-indicator.label.used": "{usedSpace} brugt",
    "wre-dashboard.space-indicator.label.unlimited": "Ubegrænset",
    "wre-dashboard.backups-table.column.name": "Navn",
    "wre-dashboard.backups-table.column.size": "Størrelse",
    "wre-dashboard.backups-table.column.version": "Sidste sikkerhedskopi",
    "wre-dashboard.backups-table.message.no-backups": "Der er endnu ingen sikkerhedskopier i clouden",
    "wre-dashboard.backups-sidebar.label.size": "Størrelse",
    "wre-dashboard.backups-sidebar.label.type": "Type",
    "wre-dashboard.backups-sidebar.label.version": "Sidste version",
    "wre-dashboard.backups-sidebar.label.created": "Oprettet",
    "wre-dashboard.backups-sidebar.label.machine": "Maskine",
    "wre-dashboard.backups-sidebar.label.owner": "Ejer",
    "wre-dashboard.content-table.column.name": "Navn",
    "wre-dashboard.content-table.column.versions": "Versioner",
    "wre-dashboard.content-table.column.volumes": "Diskenheder",
    "wre-dashboard.content-table.column.path": "Sti",
    "wre-dashboard.content-table.column.size": "Størrelse",
    "wre-dashboard.content-table.column.version": "Sidste version",
    "wre-dashboard.content-table.action.versions": "Versioner",
    "wre-dashboard.content-table.action.restore": "Download",
    "wre-dashboard.content-table.action.share": "Del link",
    "wre-dashboard.content-table.label.size": "Størrelse",
    "wre-dashboard.content-table.label.created": "Oprettet",
    "wre-dashboard.content-table.label.modified": "Ændret",
    "wre-dashboard.content-table.message.empty-folder": "Denne mappe er tom",
    "wre-dashboard.password-dialog-box.title.backup": "Krypteret sikkerhedskopi",
    "wre-dashboard.password-dialog-box.title.archive": "Krypteret arkiv",
    "wre-dashboard.password-dialog-box.message.backup": "Angiv adgangskoden for at få adgang til sikkerhedskopien {displayName}",
    "wre-dashboard.password-dialog-box.message.archive": "Angiv adgangskoden for at få adgang til arkivet {displayName}",
    "wre-dashboard.password-dialog-box.hint.password": "Adgangskode",
    "wre-dashboard.password-dialog-box.message.invalid-password": "Adgangskoden er forkert",
    "wre-dashboard.form.button.open": "Åbn",
    "wre-dashboard.form.button.close": "Luk",
    "wre-dashboard.form.button.cancel": "Annuller",
    "wre-dashboard.form.button.delete": "Slet",
    "wre-dashboard.shared-content-table.column.name": "Navn",
    "wre-dashboard.shared-content-table.column.location": "Placering",
    "wre-dashboard.shared-content-table.column.source": "Kilde",
    "wre-dashboard.shared-content-table.column.days": "Dage",
    "wre-dashboard.shared-content-table.column.downloads": "Downloads",
    "wre-dashboard.shared-content-table.column.shared": "Delt den",
    "wre-dashboard.shared-content-table.label.shared": "Delt den",
    "wre-dashboard.shared-content-table.label.backup": "Kilde",
    "wre-dashboard.shared-content-table.action.share": "Del link",
    "wre-dashboard.shared-content-table.action.settings": "Indstillinger for link",
    "wre-dashboard.shared-content-table.action.delete": "Slet link",
    "wre-dashboard.shared-content-table.action.delete-selected": "Slet links",
    "wre-dashboard.account-page.message.used-space": "{brandName}: {spaceFree} fri for {totalSpace}",
    "wre-dashboard.account-page.message.used-unlimited-space": "{brandName}: Ubegrænset plads",
    "wre-dashboard.account-page.button.sign-out": "Log ud",
    "wre-dashboard.account-page.button.manage-subscription": "Administrer licens",
    "wre-dashboard.account-page.message.subscription.active": "Din licens til {brandName} plads udløber den",
    "wre-dashboard.account-page.message.subscription.trial": "Prøveversionen af {brandName} er aktiv indtil",
    "wre-dashboard.account-page.message.subscription.expired": "Din licens til {brandName} plads udløb den",
    "wre-dashboard.account-page.message.worm-status.storage-full": "Dit {brandName}-lager er fuldt. Du kan ikke sikkerhedskopiere eller arkivere data til clouden.",
    "wre-dashboard.account-page.message.worm-status.less-than": "Der er mindre end {percent} procent ledig. Du vil snart ikke kunne bruge {brandName}.",
    "wre-dashboard.versions-dialog-box.title": "Versioner af {fileName}",
    "wre-dashboard.shared-link-dialog-box.share-view.button.copy": "Kopiér link",
    "wre-dashboard.shared-link-dialog-box.share-view.button.manage": "Indstillinger for link",
    "wre-dashboard.shared-link-dialog-box.share-view.message": "Alle med dette link kan se den seneste version af dataene",
    "wre-dashboard.shared-link-dialog-box.share-view.label.shared": "Delt den {creationDate}",
    "wre-dashboard.shared-link-dialog-box.share-view.notification.link-copied": "Link kopieret",
    "wre-dashboard.shared-link-dialog-box.share-view.notification.link-copy-error": "Fejl under kopiering af link",
    "wre-dashboard.shared-link-dialog-box.delete-view.title": "Slet link",
    "wre-dashboard.shared-link-dialog-box.delete-view.message": "Dette link fungerer ikke længere for alle, der har det",
    "wre-dashboard.shared-link-dialog-box.delete-selected-view.title": "Slet links",
    "wre-dashboard.shared-link-dialog-box.delete-selected-view.message": "Disse links holder op med at fungere for alle, der har dem",
    "wre-dashboard.shared-link-dialog-box.manage-view.title": "Indstillinger for link",
    "wre-dashboard.shared-link-dialog-box.manage-view.button.delete": "Slet link",
    "wre-dashboard.shared-link-dialog-box.manage-view.button.apply": "Udført",
    "wre-dashboard.shared-link-dialog-box.manage-view.input.hint.password": "Adgangskode",
    "wre-dashboard.shared-link-dialog-box.manage-view.button.reset-password": "Nulstil adgangskode",
    "wre-dashboard.shared-link-dialog-box.manage-view.caption.password-protection": "Adgangskodebeskyttelse",
    "wre-dashboard.shared-link-dialog-box.manage-view.message.protect-by-password": "Beskyt dette link ved at bruge en adgangskode",
    "wre-dashboard.shared-link-dialog-box.manage-view.caption.expiration": "Udløb",
    "wre-dashboard.shared-link-dialog-box.manage-view.caption.download-limits": "Grænse for download",
    "wre-dashboard.shared-link-dialog-box.manage-view.label.disable-in:plural": "Deaktiver dette link om {splitMarker} dage | Deaktiver dette link om {splitMarker} dag | Deaktiver dette link om {splitMarker} dage",
    "wre-dashboard.shared-link-dialog-box.manage-view.label.disable-after:plural": "Deaktiver dette link efter {splitMarker} downloads | Deaktiver dette link efter {splitMarker} download | Deaktiver dette link efter {splitMarker} downloads",
    "wre-dashboard.sub-accounts-dialog-box.title": "Konti",
    "wre-dashboard.sub-accounts-dialog-box.search.input.hint": "Søg",
    "wre-dashboard.sub-accounts-dialog-box.table.message.empty": "Ingen elementer matcher dine søgning",
    "wre-dashboard.sub-accounts-dialog-box.table.column.name": "Navn",
    "wre-dashboard.sub-accounts-dialog-box.table.column.usage": "Forbrug",
    "wre-dashboard.sub-accounts-dialog-box.table.column.version": "Sidste sikkerhedskopi",
    "wre-dashboard.sub-accounts-dialog-box.table.column.expires": "Udløber",
    "wre-dashboard.sub-accounts-dialog-box.label.used-space": "{spaceFree} fri for {totalSpace}",
    "wre-dashboard.sub-accounts-dialog-box.label.volume-subscription": "Volumenabonnement",
    "wre-dashboard.sub-accounts-dialog-box.label.expired": "Udløbet",
    "wre-dashboard.machines-table.column.name": "Navn",
    "wre-dashboard.machines-table.column.size": "Størrelse",
    "wre-dashboard.machines-table.message.no-machines": "Der er endnu ingen maskiner i cloudmiljøet"
};
